namespace Matrix.Data {
    export interface OwnershipProxyForm {
        InstanceCode: Serenity.LookupEditor;
        InstanceCodes: Serenity.CheckLookupEditor;
        OwnershipBasisCode: Serenity.LookupEditor;
        SecurityId: FormatServiceLookupEditor;
        AccountCode: FormatServiceLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class OwnershipProxyForm extends Serenity.PrefixedContext {
        static formKey = 'Data.OwnershipProxy';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OwnershipProxyForm.init)  {
                OwnershipProxyForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.CheckLookupEditor;
                var w2 = FormatServiceLookupEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(OwnershipProxyForm, [
                    'InstanceCode', w0,
                    'InstanceCodes', w1,
                    'OwnershipBasisCode', w0,
                    'SecurityId', w2,
                    'AccountCode', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
